<template>
    <v-layout>
UPLOADS
    </v-layout>
</template>

<script>
//import Vue from 'vue'
export default {
  name: 'Uploads',
  components: {},
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
